<div class="card-header">
  <div class="title-section">
    <h5 class="header-title">{{ model ? 'Editar' : 'Nueva' }} Movimiento de Caja</h5>
  </div>
  <div class="button-section">
    <button *ngIf="model" mat-flat-button (click)="openCustomizables()" class="btn-search" appPermissionControl="P124B0005">
      <mat-icon>settings</mat-icon>
      Customizables
    </button>
    <button
      mat-flat-button
      (click)="model ? update(form.value) : create(form.value)"
      class="{{ model ? 'btn-edit' : 'btn-success' }}"
      [disabled]="!form.valid || loading"
      appPermissionControl="P124B0002"
    >
      <mat-icon>save</mat-icon>
      {{ model ? 'Actualizar' : 'Guardar' }}
    </button>
    <button mat-flat-button (click)="close()" class="btn-delete" appPermissionControl="P124B0001">
      <mat-icon>close</mat-icon>
      Cerrar
    </button>
  </div>
</div>

<form [formGroup]="form" (ngSubmit)="model ? update(form.value) : create(form.value)" appPermissionControl="P124F0001">
  <div class="form-row mt-3">
    <div class="form-field">
      <input pInputText type="number" formControlName="iOrigen" class="form-control" [placeholder]="'Ingrese código'" [disabled]="!!model" appPermissionControl="P124K0001" />
      <label>Código</label>
      <small class="p-error" *ngIf="form.get('iOrigen')?.errors?.required && form.get('iOrigen')?.touched"> Campo requerido </small>
      <small class="p-error" *ngIf="form.get('iOrigen')?.errors?.singleCodigo"> Código en uso </small>
    </div>
  </div>

  <div class="form-row">
    <div class="form-field">
      <input pInputText type="text" formControlName="sDescripcion" class="form-control" [placeholder]="'Ingrese descripción'" appPermissionControl="P124K0002" />
      <label>Descripción</label>
      <small class="p-error" *ngIf="form.get('sDescripcion')?.errors?.required && form.get('sDescripcion')?.touched"> Campo requerido </small>
    </div>
  </div>

  <div class="form-row">
    <div class="form-field">
      <p-dropdown
        [options]="monedas"
        formControlName="moneda"
        optionLabel="descripcion"
        optionValue="moneda"
        [placeholder]="'Seleccione moneda'"
        [showClear]="true"
        [filter]="true"
        filterBy="descripcion"
        appPermissionControl="P124K0003"
      ></p-dropdown>
      <label>Moneda</label>
      <small class="p-error" *ngIf="form.get('moneda')?.errors?.required && form.get('moneda')?.touched"> Campo requerido </small>
    </div>
  </div>

  <div class="form-row">
    <div class="form-field">
      <p-dropdown
        [options]="tipoTrans"
        formControlName="iTipoTrans"
        optionLabel="sOpcion"
        optionValue="sValor"
        [placeholder]="'Seleccione tipo de transacción'"
        [showClear]="true"
        appPermissionControl="P124K0004"
      ></p-dropdown>
      <label>Tipo de Transacción</label>
      <small class="p-error" *ngIf="form.get('iTipoTrans')?.errors?.required && form.get('iTipoTrans')?.touched"> Campo requerido </small>
    </div>
  </div>

  <div class="form-row">
    <div class="form-field">
      <p-dropdown
        [options]="[
          { label: 'Sí', value: 1 },
          { label: 'No', value: 0 }
        ]"
        formControlName="iAutorizacion"
        optionLabel="label"
        optionValue="value"
        [placeholder]="'Seleccione autorización'"
        [showClear]="true"
        appPermissionControl="P124K0005"
      ></p-dropdown>
      <label>Autorización</label>
      <small class="p-error" *ngIf="form.get('iAutorizacion')?.errors?.required && form.get('iAutorizacion')?.touched"> Campo requerido </small>
    </div>
  </div>
</form>

<ng-container *ngIf="selectMoneda">
  <button mat-button color="accent" class="buttonBack" type="button" (click)="changeBoolean('form')" appPermissionControl="P124B0004"><mat-icon>west</mat-icon> Regresar</button>
  <app-select-moneda></app-select-moneda>
</ng-container>
